/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {RippleConfig, RippleRenderer} from './ripple-renderer';
export type RippleState = number;
export let RippleState: any = {};
RippleState.FADING_IN = 0;
RippleState.VISIBLE = 1;
RippleState.FADING_OUT = 2;
RippleState.HIDDEN = 3;
RippleState[RippleState.FADING_IN] = "FADING_IN";
RippleState[RippleState.VISIBLE] = "VISIBLE";
RippleState[RippleState.FADING_OUT] = "FADING_OUT";
RippleState[RippleState.HIDDEN] = "HIDDEN";

/**
 * Reference to a previously launched ripple element.
 */
export class RippleRef {
/**
 * Current state of the ripple reference.
 */
state: RippleState = RippleState.HIDDEN;
/**
 * @param {?} _renderer
 * @param {?} element
 * @param {?} config
 */
constructor(
private _renderer: RippleRenderer,
public element: HTMLElement,
public config: RippleConfig) {
  }
/**
 * Fades out the ripple element.
 * @return {?}
 */
fadeOut() {
    this._renderer.fadeOutRipple(this);
  }
}

function RippleRef_tsickle_Closure_declarations() {
/**
 * Current state of the ripple reference.
 * @type {?}
 */
RippleRef.prototype.state;
/** @type {?} */
RippleRef.prototype._renderer;
/** @type {?} */
RippleRef.prototype.element;
/** @type {?} */
RippleRef.prototype.config;
}

